// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";

class TakeRedemptionActionService {
  private dispatch = useDispatch();

  public async getRedemptionDetailsData(
    redemptionId: string | undefined
  ): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: any[];
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/redemption/${redemptionId}`);
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/redemptions/take-action/${redemptionId}`
      );
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async takeAction(
    redemptionId: string | undefined,
    action: string,
    value: string
  ): Promise<string | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    this.dispatch({ type: LOADING, payload: true });
    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/redemption/${redemptionId}/review`, {
        approved: action === "approve" ? true : false,
        [action === "approve" ? "transactionId" : "statusReason"]: value,
      });
      action === "approve"
        ? toast.success("Redemption approved successfully")
        : toast.success("Redemption rejected successfully");
      return "success";
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/redemptions/take-action/${redemptionId}`
      );
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default TakeRedemptionActionService;
